var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"userTrendFormRow"},[_c('div',{staticClass:"userTrendFormRow__label",style:({ 'min-width': _vm.minWidth }),domProps:{"textContent":_vm._s(_vm.label)}}),_c('div',{staticClass:"userTrendFormRow__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }